import { AuthError } from '../types/auth';
/**
 * Wraps an async operation with consistent error handling
 */
export async function withAuthErrorHandling(operation, options) {
    const { errorMessage, onError, setLoading, clearError, rethrow = false, } = options;
    try {
        setLoading?.(true);
        clearError?.();
        const result = await operation();
        return result;
    }
    catch (err) {
        const authError = err instanceof AuthError
            ? err
            : new AuthError('UNKNOWN_ERROR', errorMessage, err);
        onError?.(authError);
        if (rethrow) {
            throw authError;
        }
        return null;
    }
    finally {
        setLoading?.(false);
    }
}
/**
 * Specialized wrapper for operations that should always rethrow errors
 */
export async function withAuthErrorHandlingAndRethrow(operation, errorMessage, onError, setLoading, clearError) {
    const result = await withAuthErrorHandling(operation, {
        errorMessage,
        onError,
        setLoading,
        clearError,
        rethrow: true,
    });
    // This should never be null due to rethrow: true, but TypeScript needs the assertion
    return result;
}
/**
 * Specialized wrapper for operations that return nullable results
 */
export async function withAuthErrorHandlingNullable(operation, errorMessage, onError) {
    return withAuthErrorHandling(operation, {
        errorMessage,
        onError,
        rethrow: false,
    });
}
//# sourceMappingURL=error-handler.js.map